export default __webpack_public_path__ + "static/8342-6627d707f7c77c6fb75e66bc43206e19.jpg";